// extracted by mini-css-extract-plugin
export default {"cover":"P9VrQ","overlay":"_1Q1RV","content":"aXjbG"};